export class adres {
    adres!:string;
    adres_id!:number;
    adres_type_id!:number;
    city_id!:number;
    company_name!:string;
    musteri_no!:number;
    country_id!:number;
    created_at!:string;
    different_adres!:string;
    district_id!:number;
    email!:string;
    fatura_adres!:string;
    fatura_city_id!:number;
    fatura_country_id!:number;
    fatura_district_id!:number;
    lastname!:string;
    name!:string;
    order_id!:number;
    phone!:string;
    session_id!:number;
    tax_admin!:number;
    tax_number!:string;
    tckimlikno!:number;
    updated_at!:string;
    mobil_tel!:string;
    sabit_tel!:string;
    user_id!:number;
    sso_user_id!:string;
}